import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import { assetAt } from 'utils/assets';

const productImageUrl = product => {
  if (product.image) {
    return product.image.web;
  }

  return assetAt('images/placeholder.png');
};

class ProductItem extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    onToggle: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onToggle = this.onToggle.bind(this);
  }

  onToggle(id) {
    this.props.onToggle(this.props.product.id);
  }

  render() {
    const { product } = this.props;

    return (
      <tr>
        <td className="eight wide">
          <h3 className="ui image header">
            <img
              src={productImageUrl(product)}
              className="ui tiny rounded image"
              alt="Produit"
            />
            <div className="content">{product.name}</div>
          </h3>
        </td>
        <td className="right aligned four wide">
          <div className="ui toggle checkbox">
            <input
              type="checkbox"
              checked={product.active}
              onChange={this.onToggle}
            />
            <label />
          </div>
        </td>
      </tr>
    );
  }
}

export default pure(ProductItem);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/products/ProductItem.js